import "./App.css";
import { Route, Switch } from "react-router-dom";
import React from "react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./components/Home";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Map from "./components/Map";

import PrivateRoute from "./components/PrivateRoute"

import Profile from "./components/Profile";
import EditProfile from "./components/EditProfile";

import Reviews from "./components/Reviews";
import FullReview from "./components/FullReview";
import AddReview from "./components/AddReview";

import About from "./components/About";
import Privacy from "./components/Privacy";
import Licenses from "./components/Licenses";

import Signup from "./components/Signup";
import Login from "./components/Login";

import Favourites from "./components/Favourites";

import Appointments from "./components/Appointments";
import AddAppointment from "./components/AddAppointment";

import { loggedIn } from "./api";

class App extends React.Component {
  state = {
    loggedInUser: null,
    lat: 38.7117164,
    lng: -9.1264315,
  };

  setCoordinates = coordinates => {
    this.setState ({
      lat: coordinates.lat,
      lng: coordinates.lng
    }) 
  }

  async componentDidMount() {
    if (this.state.loggedInUser === null) {
      const response = await loggedIn();
      if (response.data._id) {
        this.setCurrentUser(response.data);
      }
    }
  }

  setCurrentUser = (user) => {
    this.setState({
      loggedInUser: user,
    });
  };

  render() {
    const { loggedInUser } = this.state;
    return (
      <div className="teste2">
        <ToastContainer />
        <section className="App">
        
    

          <Switch>

          <Route 
          exact path="/" 
          render={(props) => {
                return (
                  <Home
                    {...props}
                    setCoordinates={this.setCoordinates}
                  />
                )
          }}
          />

            <Route exact path="/map"   render={(props) => {
                return (
                  <Map
                    {...props}
                    lat={this.state.lat}
                    lng={this.state.lng}
                  />
                )
          }} />

            <PrivateRoute
              exact
              path="/profile"
              render={(props) => {
                return (
                  <Profile
                    {...props}
                    loggedInUser={loggedInUser}
                    setCurrentUser={this.setCurrentUser}
                  />
                );
              }}
            />
            <PrivateRoute
              exact
              path="/profile/edit"
              render={(props) => <EditProfile 
              {...props} 
              user={loggedInUser} 
              setCurrentUser={this.setCurrentUser}
              />}
            />

            <PrivateRoute
              exact
              path="/profile/reviews"
              render={(props) => {
                return (
                  <Reviews
                    {...props}
                    loggedInUser={loggedInUser}
                    setCurrentUser={this.setCurrentUser}
                  />
                );
              }}
            />
            <PrivateRoute
              exact
              path="/profile/reviews/id"
              render={(props) => {
                return (
                  <FullReview
                    {...props}
                    loggedInUser={loggedInUser}
                    setCurrentUser={this.setCurrentUser}
                  />
                );
              }}
            />
            <PrivateRoute exact path="/addreview" component={AddReview}/>



            <Route exact path="/profile/about" component={About} />
            <Route exact path="/profile/privacy" component={Privacy} />
            <Route exact path="/profile/licenses" component={Licenses} />

            <Route
              exact
              path="/login"
              render={(props) => {
                return (
                  <Login {...props} setCurrentUser={this.setCurrentUser} />
                );
              }}
            />
            <Route exact path="/signup" component={Signup} />

            <PrivateRoute exact path="/favourites" component={Favourites} />
            
            <PrivateRoute exact path="/appointments" component={Appointments} />
            <PrivateRoute exact path="/addappointment" component={AddAppointment} />
          </Switch>

          <footer className="box">
            <Footer />
          </footer>
        </section>
      </div>
    );
  }
}

export default App;
